import React from 'react';
import { Popup, PopupSettings } from 'components/common/popup/Popup';
import { Box, Stack } from '@mui/material';
import useBundleTranslation from 'i18n';
import ReactHookFormController from 'components/common/form/layout/ReactHookFormController';
import { prepareFormElementProps } from 'components/common/form/formTools';
import { useForm } from 'react-hook-form';
import { FormRendererAPIType, RawFormComponentType } from 'components/common/form';
import { conciergeAPI, FeedbackData } from 'api/concierge';

interface IProps {
    id: number;
    show: boolean;
    onHide: () => void;
    onFeedbackDone: () => void;
    question: string;
    answer: string;
    type: 'up' | 'down';
}

export default function Feedback({ id, show, onHide, question, answer, onFeedbackDone, type }: IProps) {
    const { t } = useBundleTranslation(['app/concierge/widget']);

    const { setValue: hookFormSetValue, control, getValues: hookFromGetValues, watch } = useForm({});
    const formActions = {
        hookFormControl: control,
        hookFormGetValues: hookFromGetValues,
        hookFormSetValue: hookFormSetValue,
        hookFormWatch: watch,
        formDidMount: true,
    } as FormRendererAPIType;

    const settings: PopupSettings = {
        title: t('feedback.title'),
        textOK: t('feedback.submit'),
        titleConfig: {
            icon: type === 'down' ? 'thumbs-down' : 'thumbs-up',
        },
    };

    const commentFieldControlProps = {
        form: formActions,
        component: {
            component: 'FormTextarea',
            name: 'comment',
            label: '',
            props: {
                placeholder: t(type === 'up' ? 'feedback.placeholder_up' : 'feedback.placeholder'),
            },
        } as RawFormComponentType,
    };

    const onFeedbackSubmit = () => {
        const comment = hookFromGetValues('comment');

        const feedback: FeedbackData = {
            concierge_message_id: id,
            feedback: type === 'up' ? 'like' : 'dislike',
            comment,
            answer,
            question,
        };
        conciergeAPI.provideFeedback(feedback).then(() => {
            onFeedbackDone();
        });
    };

    return show ? (
        <Popup maxWidth={'popupMd'} settings={settings} open={show} onHide={onHide} onConfirm={onFeedbackSubmit}>
            <Stack spacing={1}>
                <Box>
                    <ReactHookFormController elementProps={prepareFormElementProps(commentFieldControlProps)} />
                </Box>
            </Stack>
        </Popup>
    ) : null;
}
